import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Clock, CheckCircle, FileText, Phone, Mail, ArrowLeft } from 'lucide-react';

const OperatorPending = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Clock className="h-10 w-10 text-yellow-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Application Under Review</h1>
        <p className="text-gray-600 mb-6">
          Thank you for applying to become a Tekstar Logistics operator. Our team is reviewing your application and documents.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
          <h3 className="font-semibold text-gray-700 mb-3">What happens next?</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5" />
              <div>
                <p className="font-medium text-sm">Document Verification</p>
                <p className="text-xs text-gray-500">We verify your documents and vehicle details</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <FileText className="h-5 w-5 text-blue-500 mt-0.5" />
              <div>
                <p className="font-medium text-sm">Background Check</p>
                <p className="text-xs text-gray-500">Quick background verification for safety</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Phone className="h-5 w-5 text-purple-500 mt-0.5" />
              <div>
                <p className="font-medium text-sm">Approval Notification</p>
                <p className="text-xs text-gray-500">You'll receive SMS once approved</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-orange-700">
            <strong>Typical review time:</strong> 24-48 hours
          </p>
        </div>

        <div className="space-y-3">
          <Button 
            variant="outline"
            onClick={() => navigate('/operator/login')}
            className="w-full"
          >
            Check Application Status
          </Button>
          
          <Button 
            variant="ghost"
            onClick={() => navigate('/')}
            className="w-full"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </div>

        <div className="mt-6 pt-4 border-t text-center">
          <p className="text-sm text-gray-500 mb-2">Need help?</p>
          <div className="flex justify-center gap-4">
            <a href="mailto:support@tekstar.com" className="flex items-center gap-1 text-sm text-orange-600">
              <Mail className="h-4 w-4" />
              Email Support
            </a>
            <a href="tel:+260971000000" className="flex items-center gap-1 text-sm text-orange-600">
              <Phone className="h-4 w-4" />
              Call Us
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default OperatorPending;
